import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Calendar, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function CtaFooterSection() {
  return <section data-section-id="260661" id="צרו-קשר" className="w-full py-16 md:py-24 bg-background px-4 sm:px-6 lg:px-8 text-foreground">
      <div className="max-w-5xl mx-auto bg-primary rounded-lg p-8 md:p-16 flex flex-col items-center text-center shadow-xl">
        <div className="w-14 h-14 bg-primary-foreground/10 rounded-lg flex items-center justify-center mb-8">
          <SafeHydrate><Calendar className="w-7 h-7 text-primary-foreground" /></SafeHydrate>
        </div>
        
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-primary-foreground mb-6">
          זקוקים למטפל סיעודי באופן מיידי?
        </h2>
        
        <p className="text-lg md:text-xl text-primary-foreground/90 max-w-2xl mb-10 font-default leading-relaxed">
          אנחנו כאן כדי לספק לכם פתרון מקצועי ומהיר. מטפל מוסמך יגיע אליכם תוך 5 שעות בלבד לתיאום ציפיות והתחלת טיפול ללא התחייבות ארוכת טווח.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto mb-8">
          <Button asChild size="lg" className="w-full sm:w-auto font-default font-bold rounded-md text-base h-14 px-8 shadow-md bg-secondary text-secondary-foreground hover:bg-secondary/90">
            <Link to="/ContactPage">
              הזמינו מטפל עכשיו
            </Link>
          </Button>
          
          <Button asChild variant="secondary" size="lg" className="w-full sm:w-auto font-default font-bold rounded-md text-base h-14 px-8 bg-primary-foreground/10 text-primary-foreground hover:bg-primary-foreground/20 border-0">
            <Link to="tel:050-000-0000">
              <Phone className="ml-2 w-5 h-5" />
              חייגו לייעוץ: 050-000-0000
            </Link>
          </Button>
        </div>
        
        <p className="text-sm text-primary-foreground/70 font-default max-w-3xl">
          השירות כולל הערכת צרכים ראשונית, התאמת מטפל אישי וליווי צמוד מול הגורמים הרלוונטיים. זמין בכל רחבי הארץ.
        </p>
      </div>
    </section>;
}